// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__4uCLX","left":"Virtual_left__5fvpl","wrapper":"Virtual_wrapper__LaNpB"};